<a href="https://www.finanzen.net/" target="_blank" rel="noopener noreferrer" class="logo-link">
  <img src="/finanzen.svg" alt="finanzen.net" class="logo" />
</a>
<button class="close-btn" (click)="closeClicked.emit()">
  <img src="/closeStandalone.svg" alt="Schließen" />
</button>
